export const normalizeName = (value = '') => {
  const capitalize = (token = '') => (
    token ? `${token.charAt(0).toUpperCase()}${token.slice(1).toLowerCase()}` : ''
  );

  return String(value || '')
    .trim()
    .replace(/\s+/g, ' ')
    .split(' ')
    .map(word => word
      .split('-')
      .map(part => part
        .split("'")
        .map(capitalize)
        .join("'"))
      .join('-'))
    .join(' ')
    .trim();
};
